try{self['workbox:strategies:4.3.1']&&_()}catch(e){}// eslint-disable-line